// @flow

import t from "common/i18n";
import { consts as uploaderConsts } from "uploader";
import { asAbsolute } from "root/routes/utils";

let items: Object[];

export default () => {
	if (!items) {
		items = [{
			path: asAbsolute(uploaderConsts.SOURCES.FACEBOOK),
			title: t("facebook.menu.uploaded"),
		},
		{
			path: asAbsolute(uploaderConsts.SOURCES.FACEBOOK, "tagged"),
			title: t("facebook.menu.tagged"),
		},
		{
			path: asAbsolute(uploaderConsts.SOURCES.FACEBOOK, "albums"),
			title: t("facebook.menu.albums"),
		}];
	}

	return items;
};
